import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const BoldPlugin: Plugin = {
  name: 'bold',
  
  onKeyDown: (event: KeyboardEvent, editor: CustomEditor) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'b') {
      event.preventDefault();
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.bold === true;
      if (isActive) {
        Editor.removeMark(editor, 'bold');
      } else {
        Editor.addMark(editor, 'bold', true);
      }
      return true;
    }
    return false;
  },

  commands: {
    toggleBold: (editor: CustomEditor) => {
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.bold === true;
      if (isActive) {
        Editor.removeMark(editor, 'bold');
      } else {
        Editor.addMark(editor, 'bold', true);
      }
    }
  }
};

export default BoldPlugin; 